/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Code_CopiedInputs */

const en_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share code copied`)
};

const fr_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de partage copié`)
};

const de_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code zum Teilen kopiert`)
};

const it_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il codice copiato`)
};

const ru_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код для обмена скопирован`)
};

const es_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código compartido copiado`)
};

const zh_cn2_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享代码已复制`)
};

const ja_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有コードをコピーしました`)
};

const hi_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर कोड कॉपी हो गया`)
};

const pt_pt2_team_share_code_copied = /** @type {(inputs: Team_Share_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar código copiado`)
};

/**
* | output |
* | --- |
* | "Share code copied" |
*
* @param {Team_Share_Code_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_code_copied = /** @type {((inputs?: Team_Share_Code_CopiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Code_CopiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_code_copied(inputs)
	if (locale === "de") return de_team_share_code_copied(inputs)
	if (locale === "it") return it_team_share_code_copied(inputs)
	if (locale === "ru") return ru_team_share_code_copied(inputs)
	if (locale === "es") return es_team_share_code_copied(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_code_copied(inputs)
	if (locale === "ja") return ja_team_share_code_copied(inputs)
	if (locale === "hi") return hi_team_share_code_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_code_copied(inputs)
	return en_team_share_code_copied(inputs)
});